import React from "react"
import Modal from "react-bootstrap/Modal"
import Prefecture from "./Prefecture"
import Icon from "../../../Utils/Icon"
import Loader from "../../Loader"

import * as styles from "./Styles/SP.module.scss"
import "../Styles/modal_transition.scss"
import "../../../../styles/layouts.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const Cities = (props) => {
  const handleCancel = (e) => {
    e.preventDefault()
    props.handleCancel(e)
  }
  const handleExec = (e, c) => {
    e.preventDefault()
    props.handleExec(c, props.prefecture)
  }

  return (
    <div className={cn("right", props.show ? "show" : "")}>
      {props.prefecture && (
        <div>
          <div className={cn("row", "currentLocationOuter")}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                props.handleExec(null, null)
              }}
            >
              <div
                style={{ height: "100%" }}
                className={styles.currentLocation}
              >
                <Icon type="feather" name="map-pin" className={styles.pin} />
                <span>現在地を取得</span>
              </div>
            </a>
          </div>
          <div className="l-flex">
            <a href="#" className={styles.link} onClick={handleCancel}>
              <div className={cn("city", "cityLeft", "l-centering")}>
                <Icon
                  className={styles.chevron}
                  type="feather"
                  name="chevron-left"
                />
                全国
              </div>
            </a>
            <a
              href="#"
              className={styles.link}
              onClick={(e) => {
                handleExec(e, null)
              }}
            >
              <div className={cn("city", "cityRight", "l-centering")}>
                {props.prefecture.name}全域
              </div>
            </a>
          </div>
          <hr className="common-hr" />
          <div>
            {props.prefecture.cities.map((c, i) => (
              <React.Fragment key={i}>
                <a
                  href="#"
                  className={styles.child}
                  onClick={(e) => {
                    handleExec(e, c)
                  }}
                >
                  <div>
                    <div>{c.name}</div>
                    {Object.keys(props.placeCountByCities).length > 0 && (
                      <div className={styles.placeCount}>
                        {props.placeCountByCities[c.id] || "0"}件
                      </div>
                    )}
                  </div>
                </a>
                <hr className="common-hr" />
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

const SP = (props) => {
  return (
    <React.Fragment>
      <Modal className="half-modal" show={props.show} onHide={props.onHide}>
        <Modal.Body className={styles.modal}>
          <div className={cn("left", props.prefecture ? "hide" : "")}>
            <div className={cn("row")}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  props.onChange(null, null)
                }}
              >
                <div
                  style={{ height: "100%" }}
                  className={styles.currentLocation}
                >
                  <Icon type="feather" name="map-pin" className={styles.pin} />
                  <span>現在地を取得</span>
                </div>
              </a>
            </div>
            <Loader
              show={props.locations.length == 0}
              color="green"
              small={false}
            />
            <Prefecture {...props} onClick={props.onClick} />
          </div>
          <Cities
            show={props.cityShow}
            prefecture={props.prefecture}
            handleCancel={() => {
              props.setCityShow(false)
              setTimeout(() => {
                props.setPrefecture(null)
              }, 250)
            }}
            handleExec={(city, pref) => {
              props.onChange(city, pref)
            }}
            placeCountByCities={props.placeCountByCities}
          />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}

export default SP
